module.exports = __webpack_public_path__ + "img/sg_typography.cdeaf936.webp";